
import NOC from '@/class/common/const';

// select options
import { ISelectOption as IOption} from '@/class/models/typed/wild';

export function getOptionsText(options: IOption[] , value: number): string {
  let returnText = '';
  for (let i = 0; i < options.length; i++) {
    if (value === options[i].value) {
      returnText = options[i].text;
    }
  }
  return returnText;
}

export function checkOptionsText(options: IOption[] , value: number): boolean {
  let flag = false;
  for (let i = 0; i < options.length; i++) {
    if (value === options[i].value) {
      flag = true;
      break;
    }
  }
  return flag;
}


export const ROLE = [
  {text: NOC.SETTING.ROLE.ALL, value: NOC.SETTING.ROLE.VALUE.ALL},
  {text: NOC.SETTING.ROLE.GENERAL, value: NOC.SETTING.ROLE.VALUE.GENERAL},
  {text: NOC.SETTING.ROLE.MANAGER, value: NOC.SETTING.ROLE.VALUE.MANAGER},
  {text: NOC.SETTING.ROLE.ADMIN, value: NOC.SETTING.ROLE.VALUE.ADMIN},
] as IOption[];

export const GENDER = [
  {text: NOC.SETTING.GENDER.MAN, value: NOC.SETTING.GENDER.VALUE.MAN},
  {text: NOC.SETTING.GENDER.WOMAN, value: NOC.SETTING.GENDER.VALUE.WOMAN},
  {text: NOC.SETTING.GENDER.OTHER, value: NOC.SETTING.GENDER.VALUE.OTHER},
] as IOption[];

export const CUTOFFDAY = [
  {text: NOC.SETTING.CUTOFFDAY.DAYS5, value: NOC.SETTING.CUTOFFDAY.VALUE.DAYS5},
  {text: NOC.SETTING.CUTOFFDAY.DAYS10, value: NOC.SETTING.CUTOFFDAY.VALUE.DAYS10},
  {text: NOC.SETTING.CUTOFFDAY.DAYS15, value: NOC.SETTING.CUTOFFDAY.VALUE.DAYS15},
  {text: NOC.SETTING.CUTOFFDAY.DAYS20, value: NOC.SETTING.CUTOFFDAY.VALUE.DAYS20},
  {text: NOC.SETTING.CUTOFFDAY.DAYS25, value: NOC.SETTING.CUTOFFDAY.VALUE.DAYS25},
  {text: NOC.SETTING.CUTOFFDAY.LAST, value: NOC.SETTING.CUTOFFDAY.VALUE.LAST},
  {text: NOC.SETTING.CUTOFFDAY.SELECT, value: NOC.SETTING.CUTOFFDAY.VALUE.SELECT},
] as IOption[];

export const DAY_OF_WEEK = [
  {text: NOC.SETTING.HOLIDAY.MON, value: Number(NOC.SETTING.HOLIDAY.VALUE.MON)},
  {text: NOC.SETTING.HOLIDAY.TUE, value: Number(NOC.SETTING.HOLIDAY.VALUE.TUE)},
  {text: NOC.SETTING.HOLIDAY.WED, value: Number(NOC.SETTING.HOLIDAY.VALUE.WED)},
  {text: NOC.SETTING.HOLIDAY.THU, value: Number(NOC.SETTING.HOLIDAY.VALUE.THU)},
  {text: NOC.SETTING.HOLIDAY.FRI, value: Number(NOC.SETTING.HOLIDAY.VALUE.FRI)},
  {text: NOC.SETTING.HOLIDAY.SAT, value: Number(NOC.SETTING.HOLIDAY.VALUE.SAT)},
  {text: NOC.SETTING.HOLIDAY.SUN, value: Number(NOC.SETTING.HOLIDAY.VALUE.SUN)},
] as IOption[];

export const LEGAL_HOLIDAY = [
  {text: NOC.SETTING.LEGALHOLIDAY.ONE, value: NOC.SETTING.LEGALHOLIDAY.VALUE.ONE},
  {text: NOC.SETTING.LEGALHOLIDAY.FOUR, value: NOC.SETTING.LEGALHOLIDAY.VALUE.FOUR},
] as IOption[];

export const CONTACT = [
  // {text: NOC.CONTACT.INTRODUCTION, value: NOC.CONTACT.VALUE.INTRODUCTION},
  {text: NOC.CONTACT.OPERATION, value: NOC.CONTACT.VALUE.OPERATION},
  {text: NOC.CONTACT.PAY, value: NOC.CONTACT.VALUE.PAY},
  {text: NOC.CONTACT.CANCELLATION, value: NOC.CONTACT.VALUE.CANCELLATION},
  {text: NOC.CONTACT.REQUEST, value: NOC.CONTACT.VALUE.REQUEST},
  {text: NOC.CONTACT.OPINION, value: NOC.CONTACT.VALUE.OPINION},
  // {text: NOC.CONTACT.OTHERS, value: NOC.CONTACT.VALUE.OTHERS},
] as IOption[];
